import React from 'react';
import Truncate from "src/components/truncate";


import { createSearchParams, NavLink } from 'react-router-dom';
import { localizedStrings } from 'src/localization';

import styles from './ContactListRow.module.scss';
import withUseHooks from 'src/legacy/components/withUseHooks';
import cx from 'classnames';
import Tooltip from 'src/components/tooltip';
import _ from 'lodash';
class ContactListRow extends React.Component {
  constructor(props){
    super(props);
    this.handleContactClick = this.handleContactClick.bind(this);
    this.navigate = this.navigate.bind(this);
    this.localizedCommons = localizedStrings.commons; 
    this.state = {
      isActive: this.props.params.id===this.props.contactList.id || false 
    }
  }
  componentDidUpdate(prevProps){
    if(prevProps.params.id !== this.props.params.id){

      if(this.props.params.id === this.props.contactList.id){
      this.setState({
        isActive: true
      })
    }else{
      this.setState({
        isActive: false
      })
    }
  }
  }
  handleContactClick() {
    if(this.props.onSelection) {
      this.props.onSelection(this.props.contact);
    }
  }
  navigate(url){

    this.props.navigate({
      pathname: url,
      search:this.props.location.query.query && createSearchParams({query:this.props.location.query.query}).toString()
    });

  }
  render() {
    return (
      <div>
        {this.props.editable && this.renderContact()}
        {!this.props.editable && this._wrapContactWithLink(
          this.renderContact())
          }
      </div>
    )
  }

  _wrapContactWithLink(contact) {    
    var url = this.props.url;

    if(!url){
      url = `/settings/contact_list/${this.props.contactList.id}`;
    }
    return (

      <div onClick={()=>this.navigate(url)}>
        {contact}
      </div>
    )
  }

 

  renderContact() {
    return (
     
<> 

      <div key={this.props.contactList.id} className={cx(styles.inner,{
        
        [styles.active]: this.state.isActive && this.props.showBorders,
      
      })} onClick={this.handleContactClick}>
        <div className={styles.left}>
          <div className={styles.iconContainer}>
              <div className={styles.contactAvatar}> 
                <i className='paperflite-group' />
               </div>
          </div>
        </div>
        <div className={styles.body}>
        <Tooltip content={_.get(this.props,"contactList.name","").length > 40 ? _.get(this.props,"contactList.name") : "" }>
          <div className={styles.contactName}>
            <Truncate width={200}>{_.get(this.props,"contactList.name","")}</Truncate>
          </div>
        </Tooltip>
          <div className={styles.contactTitle}>
            <Truncate width={200}> {this.props.contactList.contactCount == 0 ?
              this.localizedCommons.no_contacts : this.props.contactList.contactCount == 1 ?
                `${this.props.contactList.contactCount} ${this.localizedCommons.contact}` :
                `${this.props.contactList.contactCount} ${this.localizedCommons.contacts}`}
            </Truncate>
          </div>
        </div>

      </div>
</>
    )
  }
}

export default withUseHooks(ContactListRow);